import { Injectable } from '@angular/core';
import { Subject  } from 'rxjs';

@Injectable()
export class CalendarService {
  protected settings: any = new Array();
  private uniqueKey: number;

  generateKey(): number {
    const randomKey = new Date().valueOf() + Math.random() * 1000;
    if (this.getDatepickerInstance() === randomKey) {
      this.generateKey();
    } else {
      return randomKey;
    }
  }
  setDatepickerInstance(instance) {
    this.uniqueKey = this.generateKey();
    this.settings[this.uniqueKey] = instance;
  }
  getDatepickerInstance() {
    return this.settings[this.uniqueKey];
  }
  destroyData() {
    delete this.settings[this.uniqueKey];
  }
}
